<template>
<div>
  <v-parallax
    dark
    src="/sumo/images/parallax/plax1.jpg"
  >
    <v-row
      align="center"
      justify="center"
    >

      <v-flex xs10 sm6 md4 lg4 text-center ma-5>
        <center>
          <v-img
            lazy-src="/sumo/images/sumologo.png"
            max-height="524"
            max-width="333"
            src="/sumo/images/sumologo.png"
          />
<br/>
        </center>
        <v-card>
          <v-card-title class='xs12 justify-center font-weight-medium display-1 pt-2'>
            Summit Mobile
          </v-card-title>
          <v-card-text>
            <h3 class='display-1 font-weight-medium light-blue--text text--darken-3'>$49</h3>
            <h3 class='font-weight-medium'>Per Month<br> $499 Setup/Installation</h3>
            <v-divider></v-divider>
            <p>
              SuMo Android & iOS<br>
              <b>Unlimited</b> Users<br>
              Image Upload<br>
            </p>
            <v-divider></v-divider>
            <p class='pa-1'>

            </p>
            <v-btn
              tile
              color="success"
              href="#contact">Get Started</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-row>
  </v-parallax>

  <v-layout row wrap justify-center ma-5>
    <v-flex xs12 sm12 md10 pa-5>
      <v-layout row wrap justify-center pa-5 text-center>
        <v-flex xs12 sm6 md4 :key="index" v-for="(channel, index) in channels">
          <v-layout row wrap align-center justify-center pa-5>
            <v-flex xs12 md12 text-xs-center>
              <v-icon size="100" color='blue-grey darken-2'>{{ channel.icon }}</v-icon>
            </v-flex>
            <v-flex xs12 sm12>
              <h3 class="headline black--text">{{ channel.headline}}</h3>
            </v-flex>
            <v-flex xs12 sm12 class='black--text'>
              {{ channel.desc }}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

</div>
</template>

<script>

  export default {
    data() {
      return {
        channels: [
          {
            headline: 'Monthly Subscription',
            desc: 'No Contracts, No commitment. Cancel Anytime',
            icon: 'mdi-calendar-month-outline'
          },
          {
            headline: 'Unlimited Users',
            desc: 'Put Summit Mobile into the hands of your staff',
            icon: 'mdi-account-group'
          },
          {
            headline: 'Android and iOS Compatible',
            desc: 'Compatible with both Android and iOS turn your mobile devices into productivity tools.',
            icon: 'mdi-cellphone-text'
          }
        ],
      }
    },
    methods: {
      popWindow(url) {
        window.open(url)
        }
      }
  }

</script>
